import { useRef, useCallback } from 'react';
export function useFunctionalRef(defaultValue) {
    var refObject = useRef(defaultValue);
    var setRef = useCallback(function (value) {
        refObject.current = value;
    }, []);
    return [refObject, setRef];
}
//# sourceMappingURL=useFunctionalRef.js.map